import type { ReactNode } from 'react'
import React from 'react'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'
import * as S from './Scrollbar.styled'

export type Props = {
  maxHeight: number
  children: ReactNode
}

export const Scrollbar = ({ maxHeight, children }: Props) => {
  return (
    <S.Container>
      <SimpleBar style={{ maxHeight }}>{children}</SimpleBar>
    </S.Container>
  )
}
